const configs = {
  classNames: {
    filter: 'allergens-filter',
  },
};

export default configs;
